import { z } from "zod";
export const OrderStripeRefundSchema = z.object({
    id: z.string().min(1), amount: z.number().int().positive(), currency: z.string(), payment_intent: z.string().nullable(),
    status: z.enum(["pending", "requires_action", "succeeded", "failed", "canceled"]).nullable(),
    metadata: z.record(z.string()).nullable().default({}),
});
export function orderStripeRefund(input) {
    const value = OrderStripeRefundSchema.parse(input);
    return { id: value.id, amount: value.amount, currency: value.currency.toUpperCase(), paymentIntent: value.payment_intent,
        status: value.status ?? "pending", operationId: value.metadata?.order_refund_id ?? null, metadata: value.metadata ?? {} };
}
export const OrderRefundEventSchema = z.object({ id: z.string().min(1), account: z.string().min(1), type: z.enum(["charge.refunded", "refund.updated"]), data: z.object({ object: z.object({ id: z.string().min(1), payment_intent: z.string().nullable().optional(), metadata: z.record(z.string()).nullable().optional() }) }) });
